import { render } from "./BButtonGroup.vue?vue&type=template&id=4a0310b4&ts=true"
import script from "./BButtonGroup.vue?vue&type=script&lang=ts"
export * from "./BButtonGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__